import React, { createContext, useContext, useCallback } from 'react';
import { Toaster, toast } from 'sonner';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const showToast = useCallback((message, type = 'success', duration = 3000) => {
    const opts = { duration };
    switch (type) {
      case 'error':
        toast.error(message, opts);
        break;
      case 'warning':
        toast.warning(message, opts);
        break;
      case 'info':
        toast.info(message, opts);
        break;
      default:
        toast.success(message, opts);
    }
  }, []);

  const success = useCallback((message, duration) => {
    showToast(message, 'success', duration);
  }, [showToast]);

  const error = useCallback((message, duration) => {
    showToast(message, 'error', duration);
  }, [showToast]);

  const warning = useCallback((message, duration) => {
    showToast(message, 'warning', duration);
  }, [showToast]);

  const info = useCallback((message, duration) => {
    showToast(message, 'info', duration);
  }, [showToast]);

  return (
    <ToastContext.Provider value={{ showToast, success, error, warning, info }}>
      {children}
      <Toaster
        position="top-center"
        richColors
        closeButton
        toastOptions={{
          style: {
            fontFamily: 'var(--pf-font)',
          },
        }}
      />
    </ToastContext.Provider>
  );
};
